import { titleCase } from "@multicines/utils";
import CheckSVG from "images/check.svg";
import React from "react";

import Styles from "./SelectInputOption.styles";
import { SelectInputOptionProps as Props } from "./SelectInputOption.types";

const SelectInputOption: React.FC<Props> = props => {
  const { className, option, isActive, onClick } = props;
  const activeStyle = isActive ? "SelectInputOption__active__container" : "";
  const selectedCheck = isActive ? <CheckSVG /> : null;

  return (
    <Styles className="SelectInputOption" onClick={() => onClick(option)}>
      <div
        className={`SelectInputOption__container ${className} ${activeStyle}`}
      >
        <p className="SelectInputOption__text">{titleCase(option)}</p>
        <div className="SelectInputOption__selected">{selectedCheck}</div>
      </div>
    </Styles>
  );
};

export default SelectInputOption;
